import { z } from "zod";
import { wishlistItem } from "./wishlistItem";
import { wishlistMetadata } from "./wishlistMeta";

export const wishlist = z.object({
  id: z.number().nullish(),
  name: z.string().nullish(),
  shareLink: z.string().nullish(),
  wishlistItems: z.array(wishlistItem).optional(),
  metadata: wishlistMetadata.optional(),
});

export type Wishlist = z.infer<typeof wishlist>;
